export const CITIZENSHIP_STORAGE_KEY = 'citizenshipPreference';
export const DEFAULT_CITIZENSHIP_ID = 'belarus';

export const getSavedCitizenship = (allowedIds = []) => {
    try {
        const raw = window.localStorage.getItem(CITIZENSHIP_STORAGE_KEY);
        if (!raw) {
            return DEFAULT_CITIZENSHIP_ID;
        }
        const saved = JSON.parse(raw);
        if (allowedIds.length && !allowedIds.includes(saved)) {
            return DEFAULT_CITIZENSHIP_ID;
        }
        return saved || DEFAULT_CITIZENSHIP_ID;
    } catch (e) {
        return DEFAULT_CITIZENSHIP_ID;
    }
};

export const saveCitizenship = (citizenshipId) => {
    try {
        if (!citizenshipId || citizenshipId === DEFAULT_CITIZENSHIP_ID) {
            window.localStorage.removeItem(CITIZENSHIP_STORAGE_KEY);
            return;
        }
        window.localStorage.setItem(CITIZENSHIP_STORAGE_KEY, JSON.stringify(citizenshipId));
    } catch (e) {
        // ignore quota / private mode errors
    }
};

export const clearSavedCitizenship = () => {
    try {
        window.localStorage.removeItem(CITIZENSHIP_STORAGE_KEY);
    } catch (e) {
        // ignore
    }
};
